import { REACT_APP_SESSION_LIMIT } from "../Components/processENV";
import {
  getFromLocalStorageAndDecrypt,
  encryptAndStoreInLocalStorage,
  deleteItemFromLocalStorage,
  encryptAndStoreInSessionStorage
} from "../Components/WebChat/WebChatEncryptDecrypt";
import { logout } from "../Helpers/Utility";


// const SESSION_LIMIT = REACT_APP_SESSION_LIMIT || 6 * 60 * 60 * 1000; // 6 hours 
const SESSION_LIMIT = parseInt(REACT_APP_SESSION_LIMIT)
const SESSION_KEY = "session_start_time";
// const CHECK_INTERVAL = 10000; // 10 seconds
const CHECK_INTERVAL = 60 * 1000; // 1 minute

const WARNING_TIME = 5 * 60 * 1000; // 5 minutes before logout
const WARNING_SHOWN_KEY = "session_warning_shown";

let intervalId = null;
let countdownIntervalId = null;
let countdownActive = false;

const SessionManager = {
  start() {
    if (!getFromLocalStorageAndDecrypt(SESSION_KEY)) {
      encryptAndStoreInLocalStorage(SESSION_KEY, Date.now());
      deleteItemFromLocalStorage(WARNING_SHOWN_KEY);
      // encryptAndStoreInLocalStorage("last_check_time", Date.now());
    }
    else {
      this.check();
    }
    this.startWatcher();
  },

  // detectTimeManipulation() {
  //   const lastCheckTime = getFromLocalStorageAndDecrypt("last_check_time");
  //   const currentTime = Date.now();
    
  //   if (lastCheckTime) {
  //     const timeDiff = currentTime - parseInt(lastCheckTime, 10);
      
  //     // If time jumped backward or forward too much (more than 2 minutes beyond normal check interval)
  //     if (timeDiff < 0 || timeDiff > CHECK_INTERVAL + 2 * 60 * 1000) {
  //       console.warn("System time changed detected");
  //       return true;
  //     }
  //   }
    
  //   encryptAndStoreInLocalStorage("last_check_time", currentTime);
  //   return false;
  // },

  startCountdown() {
    if (countdownActive) return;

    countdownActive = true;

    countdownIntervalId = setInterval(() => {
      const remaining = this.remainingTime();

      if (remaining <= 0) {
        clearInterval(countdownIntervalId);
        countdownIntervalId = null;
        this.logout();
        return;
      }

      const minutes = Math.floor(remaining / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      document.getElementById("session-timer")?.remove();

      const popup = document.createElement("div");
      popup.id = "session-timer";
      popup.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #fff3cd;
        color: #856404;
        padding: 16px;
        border: 1px solid #ffeeba;
        border-radius: 8px;
        z-index: 9999;
        font-size: 14px;
        font-weight: bold;
        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
      `;

      popup.innerText = `⚠️ Session expires in ${minutes}:${seconds
        .toString()
        .padStart(2, "0")}`;

      document.body.appendChild(popup);
    }, 1000);
  },


  isExpired() {
    const startTime = getFromLocalStorageAndDecrypt(SESSION_KEY);
    if (!startTime) return true;
    return Date.now() - parseInt(startTime, 10) > SESSION_LIMIT;
  },

  remainingTime() {
    const startTime = getFromLocalStorageAndDecrypt(SESSION_KEY);
    if (!startTime) return 0;
    return Math.max(
      0,
      SESSION_LIMIT - (Date.now() - parseInt(startTime, 10))
    );
  },

  async logout() {
    if (countdownIntervalId) {
      clearInterval(countdownIntervalId);
      countdownIntervalId = null;
    }
    const timerPopup = document.getElementById("session-timer");
    timerPopup?.remove();
    this.stopWatcher();

    // deleteItemFromLocalStorage("last_check_time");
    // deleteItemFromLocalStorage(WARNING_SHOWN_KEY);

    // alert("Your session has expired. Please log in again to continue your activity.");
    logout("sessionManager");
  },

  check() {
    // if (this.detectTimeManipulation()) {
    //   alert("System time manipulation detected. For security, you will be logged out.");
    //   this.logout();
    //   return;
    // }
    const remaining = this.remainingTime();
    if (remaining > 0 && remaining <= WARNING_TIME) {
      this.startCountdown();
    }

    if (this.isExpired()) {
      this.logout();
    }
  },

  startWatcher() {
    if (!intervalId) {
      intervalId = setInterval(() => this.check(), CHECK_INTERVAL);
    }
  },

  stopWatcher() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }
};

export default SessionManager;